import React from 'react';
import {Image} from 'react-native';

export default function Searching({ width, height } : SvgProps) {
  return <Image style={{ width, height }} source={require('./undraw_searching_re_3ra9.svg')} />
};

